<script setup lang="ts">
import { ref } from "vue";
import { ArrowUpRight, Menu, X } from "lucide-vue-next";
import "@/assets/styles/sidebar.css";

const isOpen = ref(false);

const close = () => {
  isOpen.value = false;
};
</script>

<template>
  <header class="site-header">
    <a class="nav-brand" href="#home" aria-label="Freiraum Startseite" @click="close">
      <span class="brand-mark">F</span>
      <span class="brand-copy">
        <strong>FREIRAUM</strong>
        <small>Garten · Landschaft · Pflege</small>
      </span>
    </a>

    <nav class="desktop-nav" aria-label="Hauptnavigation">
      <a href="#about">Unternehmen</a>
      <a href="#services">Leistungen</a>
      <a href="#references">Projekte</a>
      <a href="#reviews">Stimmen</a>
    </nav>

    <a class="nav-cta" href="#contact">
      Projekt anfragen
      <ArrowUpRight :size="17" />
    </a>

    <button class="menu-btn" type="button" aria-label="Menü öffnen" :aria-expanded="isOpen" @click="isOpen = !isOpen">
      <X v-if="isOpen" />
      <Menu v-else />
    </button>
  </header>

  <div v-if="isOpen" class="menu-backdrop" @click="close" />
  <aside class="mobile-menu" :class="{ open: isOpen }" aria-label="Mobile Navigation">
    <span class="menu-kicker">Navigation</span>
    <nav>
      <a href="#home" @click="close">Start</a>
      <a href="#about" @click="close">Unternehmen</a>
      <a href="#services" @click="close">Leistungen</a>
      <a href="#references" @click="close">Projekte</a>
      <a href="#reviews" @click="close">Kundenstimmen</a>
      <a href="#contact" @click="close">Kontakt</a>
    </nav>
    <p>Außenräume, die funktionieren.<br />Für Menschen, Teams und Orte.</p>
  </aside>
</template>
